export default {
    categories: {
        company: {
            title: window.i18n.__('Société'),
            subtitle: window.i18n.__('Données société'),
        },
        address: {
            title: window.i18n.__('Adresse'),
            subtitle: window.i18n.__('Données adresse'),
        },
        contact: {
            title: window.i18n.__('Contact'),
            subtitle: window.i18n.__('Données contact'),
        },
    },
    rows: [
        {
            category: 'company',
            label: window.i18n.__('Identifiant société'),
            description: {
                text: window.i18n.__('Récupéré depuis un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Type société'),
            description: {
                text: window.i18n.__('Type de société parmi les 3 existants'),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Type parmi la liste suivante : '),
                description: window.i18n.__('"client”, “prospect”, “fournisseur”'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Nom société'),
            description: {
                text: window.i18n.__('Nom de la société'),
            },
            mandatory: true,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Référence'),
            description: {
                text: window.i18n.__('Référence de la société affichée sur la fiche société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Forme juridique'),
            description: {
                text: window.i18n.__('Statut juridique de la société'),
                subtext: window.i18n.__('SA, SAS, SARL, EURL…'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Catégorie tarifaire'),
            description: {
                text: window.i18n.__('Nom de la catégorie tarifaire de société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Email'),
            description: {
                text: window.i18n.__('Adresse email de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Adresse email'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Téléphone'),
            description: {
                text: window.i18n.__('Numéro de téléphone fixe de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Mobile'),
            description: {
                text: window.i18n.__('Numéro de téléphone mobile de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Fax'),
            description: {
                text: window.i18n.__('Numéro de fax de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Site internet'),
            description: {
                text: window.i18n.__('URL du site internet de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('TVA'),
            description: {
                text: window.i18n.__('N° de TVA intracommunautaire de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('NAF'),
            description: {
                text: window.i18n.__('Code NAF (APE) de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Capital social'),
            description: {
                text: window.i18n.__('Montant de l’apport à la création de la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('RCS'),
            description: {
                text: window.i18n.__('Numéro du Registre du Commerce et des Sociétés'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('SIRET'),
            description: {
                text: window.i18n.__(
                    'Numéro du Système d’Identification du Répertoire des ETablissements de la société',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('SIREN'),
            description: {
                text: window.i18n.__(
                    'Numéro du Système d’Identification du Répertoire des ETablissements de la société',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Note'),
            description: {
                text: window.i18n.__('Contenu affiché dans le champ note de la fiche société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Smart-Tags'),
            description: {
                text: window.i18n.__('Liste de smart-tags'),
            },
            mandatory: false,
            value: {
                text: 'Alphanumérique',
                subtext: window.i18n.__('À séparer par une virgule'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Propriétaire'),
            description: {
                text: window.i18n.__('Propriétaire de la société'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                "Si ce champ n'est pas renseigné alors le nom d’utilisateur qui initie l’import sera ajouté",
            ),
            value: {
                text: window.i18n.__('Nom complet du propriétaire de la société importée'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Compte tiers'),
            description: {
                text: window.i18n.__('Code comptable à associer à ce tiers'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Compte auxiliaire'),
            description: {
                text: window.i18n.__('Code comptable auxiliaire à associer à ce tiers'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Inscrit campagnes email'),
            description: {
                text: window.i18n.__('Détermine si la société est inscrite aux campagnes email'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Inscrit campagnes SMS'),
            description: {
                text: window.i18n.__('Détermine si la société est inscrite aux campagnes SMS'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Inscrit campagnes téléphonique'),
            description: {
                text: window.i18n.__(
                    'Détermine si la société est inscrite aux campagnes téléphoniques',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Inscrit campagnes courrier'),
            description: {
                text: window.i18n.__('Détermine si la société est inscrite aux campagnes courrier'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Inscrit campagnes marketing personnalisé'),
            description: {
                text: window.i18n.__(
                    'Détermine si la société est inscrite aux campagnes marketing personnalisé',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'company',
            label: window.i18n.__('Archivée'),
            description: {
                text: window.i18n.__('Archiver ou non la société'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Identifiant adresse'),
            description: {
                text: window.i18n.__('Récupéré uniquement depuis un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Nom adresse'),
            description: {
                text: window.i18n.__('Nom associé à l’adresse'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Adresse'),
            description: {
                text: window.i18n.__('Adresse principale'),
                subtext: window.i18n.__('Numéro et adresse'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                'Ce champ devient obligatoire si d’autres \n champs adresse sont renseignés',
            ),
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Complément d’adresse'),
            description: {
                text: window.i18n.__('Complément d’adresse'),
                subtext: window.i18n.__('Bâtiment, étage, bureau…'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Complément d’adresse 2'),
            description: {
                text: window.i18n.__('Deuxième complément d’adresse'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Complément d’adresse 3'),
            description: {
                text: window.i18n.__('Troisième complément d’adresse'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Code postal'),
            description: {
                text: window.i18n.__('Code postal correspondant à l’adresse'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                'Ce champ devient obligatoire si d’autres \n champs adresse sont renseignés',
            ),
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Ville'),
            description: {
                text: window.i18n.__('Ville correspondant à l’adresse'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                'Ce champ devient obligatoire si d’autres \n champs adresse sont renseignés',
            ),
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('État / Province'),
            description: {
                text: window.i18n.__('Utile uniquement pour des adresses non françaises'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'address',
            label: window.i18n.__('Code pays'),
            description: {
                text: window.i18n.__('Code ISO du pays'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Code ISO 3166-1 (ex : FR, DE, ES…)'),
                link: {
                    label: window.i18n.__('Listes des codes pays'),
                    href: 'https://fr.wikipedia.org/wiki/ISO_3166-1#Table_de_codage',
                },
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Identifiant contact'),
            description: {
                text: window.i18n.__('Récupéré uniquement depuis un export Sellsy'),
                subtext: window.i18n.__('Utile uniquement en cas de mise à jour'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Numérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Civilité contact'),
            description: {
                text: window.i18n.__('Civilité du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Type contact principal'),
            description: {
                text: window.i18n.__('Détermine si le contact est de type “contact principal”'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Type contact de facturation'),
            description: {
                text: window.i18n.__(
                    'Détermine si le contact est de type “contact de facturation”',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Type contact de relance'),
            description: {
                text: window.i18n.__('Détermine si le contact est de type “contact de relance”'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Nom contact'),
            description: {
                text: window.i18n.__('Nom de famille du contact'),
            },
            mandatory: false,
            mandatoryTooltip: window.i18n.__(
                'Ce champ devient obligatoire si d’autres \n champs contact sont renseignés',
            ),
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Prénom contact'),
            description: {
                text: window.i18n.__('Prénom du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Email contact'),
            description: {
                text: window.i18n.__('Adresse email du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Adresse email'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Téléphone contact'),
            description: {
                text: window.i18n.__('Numéro de téléphone fixe du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Mobile contact'),
            description: {
                text: window.i18n.__('Numéro de téléphone mobile du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Fax contact'),
            description: {
                text: window.i18n.__('Numéro de fax du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Téléphone au format international ou national'),
                subtext: window.i18n.__('+33xxxxxxxxx ou 0234567890'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Site internet contact'),
            description: {
                text: window.i18n.__('URL du site internet du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Fonction contact'),
            description: {
                text: window.i18n.__('Fonction du contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Smart-tags contact'),
            description: {
                text: window.i18n.__('Liste de smart-tags'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Smart Tag(s) parmi la liste existante'),
                subtext: window.i18n.__('À séparer par une virgule'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Note contact'),
            description: {
                text: window.i18n.__('Contenu affiché dans le champ note de la fiche contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('Alphanumérique'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes email contact'),
            description: {
                text: window.i18n.__('Détermine si le contact est inscrit aux campagnes email'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes SMS contact'),
            description: {
                text: window.i18n.__('Détermine si le contact est inscrit aux campagnes SMS'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes téléphonique contact'),
            description: {
                text: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes téléphoniques',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes courrier contact'),
            description: {
                text: window.i18n.__('Détermine si le contact est inscrit aux campagnes courrier'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Inscrit campagnes marketing personnalisé contact'),
            description: {
                text: window.i18n.__(
                    'Détermine si le contact est inscrit aux campagnes marketing personnalisées',
                ),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
        {
            category: 'contact',
            label: window.i18n.__('Contact archivé'),
            description: {
                text: window.i18n.__('Archiver ou non le contact'),
            },
            mandatory: false,
            value: {
                text: window.i18n.__('“Y” pour oui ou “N” pour non'),
            },
        },
    ],
};
